<template>
  <div id="waitSpotlight">

    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>注目の的</b></p>
    <div v-if="haveSpotlight">
      <div class="wait-decline-area">
        <p><span v-on:click="showEffect(9)" class="plot-name"><b><u>注目の的</u></b></span>を使用しますか．</p>
        <v-container fluid>
          <v-row justify="center">
            <div class="agree">
              <agreeButton v-if="picked=='true'" label="する" active='true' />
              <agreeButton v-else v-on:pushed="setPick('true')" label="する" active='false' />
            </div>
            <div class="disagree">
              <disagreeButton v-if="picked=='false'" label="しない" active='true' />
              <disagreeButton v-else v-on:pushed="setPick('false')" label="しない" active='false' />
            </div>
          </v-row>
        </v-container>
      </div>

      <v-expand-transition>
        <v-card
          v-show="picked=='true'"
          elevation=0
          class="background-color"
        >
          <v-row class="mx-auto">
            <v-col class="my-n2" v-for="(user, key) in assignedUsers.filter(user => user.id != userId )" v-bind:key="user.name" >
              <v-card v-if="assignedUsers.filter(user => user.id != userId).length>1" class="" elevation=0 max-width=240 min-width=240>
                <div style="text-align:left;">
                  <v-simple-table dense >
                    <td class="assigning-td" style="width:90px;">
                      <div class="assign-button background-color">
                        <pickButton v-if="isSelected[key]" v-on:pushed="select(key)" activeLabel="選択" inactiveLabel="未選択" active="true" />
                        <pickButton v-else v-on:pushed="select(key)" activeLabel="選択" inactiveLabel="未選択" active="false" />
                      </div>
                    </td>
                    <td class="assigning-td" style="padding-left:12px;width:140px">
                      <span class="user-label">{{ user.name }}</span>
                    </td>
                  </v-simple-table>
                </div>
              </v-card>
              <v-card v-else class="mx-auto" elevation=0 max-width=240 min-width=240>
                <div style="text-align:left;">
                  <v-simple-table dense >
                    <td class="assigning-td" style="width:90px;">
                      <div class="assign-button background-color">
                        <pickButton v-if="isSelected[key]" v-on:pushed="select(key)" activeLabel="選択" inactiveLabel="未選択" active="true" />
                        <pickButton v-else v-on:pushed="select(key)" activeLabel="選択" inactiveLabel="未選択" active="false" />
                      </div>
                    </td>
                    <td class="assigning-td" style="padding-left:12px;width:140px">
                      <span class="user-label">{{ user.name }}</span>
                    </td>
                  </v-simple-table>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-expand-transition>

      <div class="send-button">
        <sendButton v-if="picked=='false'||selected" v-on:pushed="push" label="決定" active="true"/>
        <sendButton v-else label="決定" active="false"/>
      </div>
    </div>
    <div v-else>
      <p>{{ executer.name }}が<span v-on:click="showEffect(9)" class="plot-name"><b><u>注目の的</u></b></span>を使用するのを待っています．</p>
    </div>
  </v-card>

  <v-card
    class="mx-auto my-4"
    max-width="400"
    color="#DDDDFF"
  >
    <div class="assigned-card">
      <p style="color:#444499"><b>ミッションメンバー</b></p>
      <div class="assigned-table">
      <v-simple-table dense>
        <template v-slot:default>
          <tbody>
            <tr v-for="assigned in assignedUsers" :key="assigned.name">
              <td>{{ assigned.name }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    </div>
  </v-card>

  </div>
</template>
<script>
import agreeButton from '@/components/gameUiComponents/AgreeButton.vue'
import disagreeButton from '@/components/gameUiComponents/DisagreeButton.vue'
import pickButton from '@/components/gameUiComponents/PickedButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "waitSpotlight",
  plops: [],
  components: {
    agreeButton,
    disagreeButton,
    pickButton,
    sendButton
  },
  data() {
    return {
      picked: '',
      selected: '',
      isSelected: [],
      socket: this.$store.state.webSocket.socket,
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      sent: false,
    };
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    haveSpotlight() {
      for (var i in this.users){
        if (this.users[i].id == this.userId){
          const plotCards = this.users[i].plots.filter(plot => plot.id == 9 && !plot.done)
          if (plotCards.length > 0){
            return true
          }
        }
      }
      return false
    },
    executer () {
      var leaderIndex = 0;
      for (var i=0; i<this.users.length; i++){
        if(this.users[i].isLeader){
          leaderIndex = i;
          break
        }
      }
      var executer = []
      for (i=0; i<this.users.length; i++){
        // カードごとの処理
        // for (var j=0; j<this.users[(leaderIndex+i)%this.users.length].plots.filter(plot => plot.id == 2 && !plot.done).length; j++){
        //   executer.push(this.users[(leaderIndex+i)%this.users.length])
        // }

        // プレイヤごとの処理
        if(this.users[(leaderIndex+i)%this.users.length].plots.find(plot => plot.id == 9 && !plot.done)){
          executer.push(this.users[(leaderIndex+i)%this.users.length])
        }
      }
      return executer.length > 0 ? executer[0] : null
    },
    assignedUsers() {
      return this.$store.state.missionInfo.assignedUsers
    },
  },
  methods: {
    select(num) {
      if (this.isSelected[num]){
        this.$set(this.isSelected, num, false)
      }else {
        for (var i=0; i<this.isSelected.length; i++){
          this.$set(this.isSelected, i, false)
        }
        this.$set(this.isSelected, num, true)
        this.selected = this.users.filter(user => user.id != this.userId )[num].name
      }
    },
    setPick(pick) {
      this.picked = pick
      if (pick == 'false') {
        for (var i in this.isSelected){
          this.$set(this.isSelected, i, false)
        }
        this.selected = ''
      }
    },
    push(){
      var selected = "None"
      if (this.picked == "true"){
        selected = this.users.filter(user => user.id != this.userId)[this.isSelected.indexOf(true)].id
      }else if (this.picked == "false"){
        selected = "None"
      }else {
        return
      }
      // this.sent=true
      this.$emit("send-request", {"action": "decide-spotlight", "roomId": this.roomId, "userId": this.userId, data: {"spotlight": selected}})
    },
    showEffect: function(id){
      var plot = this.$store.getters.getPlotEffect(id);
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    },
  },
  created () {
    for (var i=0; i<this.users.filter(user => user.id != this.userId).length; i++ ){
      this.isSelected.push(false)
    }
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      // "wait-spotlight" or "running-mission"
      var snackText = ""
      if (res.data.spotlight=='None'){
        snackText = "注目の的は使用されませんでした．"
      }else {
        snackText = self.$store.getters.getUserById(res.data.holder).name
        snackText += "が注目の的を"
        snackText += self.$store.getters.getUserById(res.data.spotlight).name
        snackText += "に使用しました．"
        snackText += self.$store.getters.getUserById(res.data.spotlight).name
        snackText += "のミッション行動は公開されます．"
        self.$store.commit('deletePlot', {'userId': res.data.holder, 'plotId': 9})
      }
      self.$emit("show-text", {state: "decide-watcher", text: snackText})

      var nextState = "running-mission"
      if (res.state == "running-mission"){
        nextState = "runningMission"
      }
      self.$emit("proceed-state", nextState)
    }
  }
}
</script>
<style>
#waitSpotlight .send-button {
  padding-top: 12px;
  padding-bottom: 12px
}
#waitSpotlight .assigning-table {
 margin-top: 24px;
 align-items: left;
 display: inline-block;
 text-align:center;
}
#waitSpotlight .td-assigning {
  font-size: 16px;
  border-bottom-width: 0px;
  background-color: #F6F6FA;
}
#waitSpotlight .background-color {
  background-color: #F6F6FA;
}

#waitSpotlight .agree {
  margin-right: 12px
}
#waitSpotlight .agree {
  background-color:#FFFFFF
}

#waitSpotlight .user-button {
  margin-right: 12px;
  margin-bottom: 12px;
  background-color: #FFF;
}
#waitSpotlight .assigned-table{
  align-items: center;
  flex-direction: column;
  display: inline-block;
  text-align:center;
  min-width: 200px
}
#waitSpotlight .plot-name {
  color: #5555BB;
  cursor:pointer;
}
#waitSpotlight .assigning-td {
  font-size: 16px;
  border-bottom-width: 0px;
  padding-top: 1px;
  padding-bottom: 1px;
  background-color: #F6F6FA;
}
</style>
